//todo: check when we using status and lead
// const paramsCustomer = [
//   "STATUS",
//   "LEAD",
//   "CID",
//   "GCLID",
//   "CAMPAIGNID",
//   "CLIENTID",
//   "UTM_SOURCE",
//   "UTM_MEDIUM",
//   "UTM_CAMPAIGN",
//   "REFERRER",
// ];

const queryCampaignParams = ['clientId', 'referrer', 'utm_source', 'utm_medium','utm_campaign', 'gclid', 'campaignid', 'fbclid'];

// method for the passing url data of user to order
export function extractUrlOfCustomer(): object {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const customerAdditions:Record<string, any> = {};
  for (let queryName of queryCampaignParams) {
    if (urlParams.has(queryName)) {
      customerAdditions[queryName] = urlParams.get(queryName)
    }
  }
  return customerAdditions;
}
